import type { GetStaticProps } from 'next';
import BenefitsMarquee from '@/components/BenefitsMarquee';
import FAQs from '@/components/FAQs';
import CreatorBenefits from '@/components/ReferAndEarn/CreatorBenefits';
import Hero from '@/components/ReferAndEarn/Hero';
import HowItWorks from '@/components/ReferAndEarn/HowItWorks';
import MediaKit from '@/components/ReferAndEarn/MediaKit';
import PartnerProgram from '@/components/ReferAndEarn/PartnerProgram';
import SupportArtists from '@/components/ReferAndEarn/SupportArtists';
import Who from '@/components/ReferAndEarn/Who';
import Why from '@/components/ReferAndEarn/Why';
import { SEO } from '@/components/SEO';
import { creators, benefits, features, faqs } from './content';
import useSEO from '@/hooks/seo/useSEO';
import type { ReferAndEarnProps } from '@/types/referAndEarn';
const ReferAndEarn = ({
  features,
  who,
  benefits,
  faqs
}: ReferAndEarnProps) => {
  const {
    generateNewTitle
  } = useSEO();
  const title = generateNewTitle({
    title: 'Refer & Earn',
    excludeTagline: true
  });
  return <>
      <SEO description="Share Uppbeat with your audience to earn and unlock rewards" title={title} data-sentry-element="SEO" data-sentry-source-file="index.page.tsx" />
      <article className="flex flex-col gap-10 2xl:gap-20">
        <div className="flex flex-col gap-3 2xl:gap-6">
          <Hero data-sentry-element="Hero" data-sentry-source-file="index.page.tsx" />
          <BenefitsMarquee features={features} data-sentry-element="BenefitsMarquee" data-sentry-source-file="index.page.tsx" />
        </div>
        <main className="flex flex-col gap-5 2xl:gap-10">
          <PartnerProgram data-sentry-element="PartnerProgram" data-sentry-source-file="index.page.tsx" />
          <HowItWorks data-sentry-element="HowItWorks" data-sentry-source-file="index.page.tsx" />
          <Why data-sentry-element="Why" data-sentry-source-file="index.page.tsx" />
          <Who who={who} data-sentry-element="Who" data-sentry-source-file="index.page.tsx" />
          <MediaKit data-sentry-element="MediaKit" data-sentry-source-file="index.page.tsx" />
          <CreatorBenefits benefits={benefits} data-sentry-element="CreatorBenefits" data-sentry-source-file="index.page.tsx" />
          <SupportArtists data-sentry-element="SupportArtists" data-sentry-source-file="index.page.tsx" />
          <div className="special-page-container">
            <FAQs className="mb-0 md:mb-0" faqs={faqs} data-sentry-element="FAQs" data-sentry-source-file="index.page.tsx" />
          </div>
        </main>
      </article>
    </>;
};
export const getStaticProps: GetStaticProps<ReferAndEarnProps> = () => ({
  props: {
    features,
    who: creators,
    benefits,
    faqs
  }
});
export default ReferAndEarn;